import React from "react";

export default function HyperLink({
  code,
  baseUrl = "https://hajexbolt.com/tracking?tracking_id=",
  color = "var(--color-brand)",
}) {
  if (!code) return null;

  return (
    <a
      href={`${baseUrl}${code}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color,
        textDecoration: "inherit",
      }}
    >
      {code}
    </a>
  );
}
